import React, { useEffect, useRef } from "react";
import { FaExpand, FaCompress } from "react-icons/fa";
import { useFullScreen } from "@cadenza/ui-hooks";
import CSButton from "./CSButton.jsx";

const FullScreenButton = ({
  elementId, // optional: target by id
  targetRef, // optional: pass a ref instead
  fullLabel = "Full Screen",
  exitLabel = "Exit Full Screen",
  ...btnProps
}) => {
  const internalRef = useRef(null);
  const ref = targetRef ?? internalRef;
  const { isFullscreen, toggle } = useFullScreen(ref);

  useEffect(() => {
    if (elementId && ref.current == null) {
      ref.current = document.getElementById(elementId);
    }
  }, [elementId, ref]);

  const label = isFullscreen ? exitLabel : fullLabel;

  return (
    <CSButton onClick={toggle} title={label} aria-label={label} {...btnProps}>
      {isFullscreen ? (
        <FaCompress className="cs-icon" />
      ) : (
        <FaExpand className="cs-icon" />
      )}
    </CSButton>
  );
};

export default FullScreenButton;
